<div class="head" mat-dialog-title>
  <h3 class="mat-dialog-title">{{data.title}}</h3>
</div>

<div class="body" mat-dialog-content>
  {{data.message}}
</div>

<div class="footer" matDialogActions align="end">
  <ng-container *ngIf="data.type === ConfirmDialogDataTypeEnum.DEFAULT else infoType">
    <button mat-button class="button-with-spacing-1_25" (click)="onSuccess()" color="accent">
      ДА
    </button>
    <button mat-button class="button-with-spacing-1_25" (click)="onClose()">ОТМЕНА</button>
  </ng-container>

  <ng-template #infoType>
    <button mat-button class="button-with-spacing-1_25" (click)="onClose()">OK</button>
  </ng-template>
</div>

